import { Injectable, Injector } from '@angular/core';
import { BrowserStorageService } from '../../shared/services/storage.service';
import { PatientResponse } from '../../shared/service-proxies/service-proxies';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BusquedaPacientesService {

    pacienteSeleccionadoKey = 'PacienteSeleccionado';

    public pacienteSeleccionado: Observable<PatientResponse>;
    private pacienteSeleccionadoSubject: BehaviorSubject<PatientResponse>;

    constructor(injector: Injector,
        private browserStorageService: BrowserStorageService) {

        const pSaved = browserStorageService.get(this.pacienteSeleccionadoKey);

        if (pSaved) {
            this.pacienteSeleccionadoSubject = new BehaviorSubject<PatientResponse>(pSaved);
        } else {
            this.pacienteSeleccionadoSubject = new BehaviorSubject<PatientResponse>(null);
        }

        this.pacienteSeleccionado = this.pacienteSeleccionadoSubject.asObservable();
    }

    public get pacienteActivo(): PatientResponse {
        return this.pacienteSeleccionadoSubject ? this.pacienteSeleccionadoSubject.value : null;
    }

    setPatient(pSel: PatientResponse): void {
        const self = this;

        self.browserStorageService.set(self.pacienteSeleccionadoKey, pSel);
        self.pacienteSeleccionadoSubject.next(pSel);
    }

    removePatient(): void {
        const self = this;

        self.browserStorageService.remove(self.pacienteSeleccionadoKey);
        self.pacienteSeleccionadoSubject.next(null);
    }
}
